import { CSSProperties } from 'react';
import { FieldHeaderComponent } from '@vivli/shared/components';
import { Color } from '@vivli/shared/theme';
import { TeamMemberModalComponent } from './team-member-modal.component';
import {
    useResearchTeamCreate,
    useResearchTeamMemberId,
    useResearchTeamPermissions
} from '@vivli/features/data-requests/infrastructure/hook';
import { IDataRequest, IResearchTeamMemberDetail } from '@vivli/features/data-requests/infrastructure/interface';
import { ResearchTeamMemberRoleEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { ButtonView, LoadIndicatorView } from '@vivli/shared/views';
import { ResearchTeamGridComponent } from './research-team-grid.component';

const containerStyle: CSSProperties = {
    width: `100%`,
    display: 'grid',
    gridAutoRows: 'auto',
    rowGap: '20px'
};

const btnStyle = {
    backgroundColor: Color.WHITE,
    borderColor: '#A0A0A0',
    borderWidth: 1,
    borderStyle: 'solid',
    color: '#A0A0A0'
};

interface ResearchTeamListFeatureProps {
    dataRequest: IDataRequest;
    researchTeamMembers: IResearchTeamMemberDetail[];
    onRemove?: (teamMember: IResearchTeamMemberDetail) => void;
    onSave?: (teamMember: IResearchTeamMemberDetail) => void;
    onAdd?: (teamMember: IResearchTeamMemberDetail) => void;
    teamMembersLoading?: string[];
    onChange?: (dataRequest: IDataRequest) => void;
    title?: string;
}

export const ResearchTeamListComponent = ({
    dataRequest,
    researchTeamMembers,
    onRemove,
    onChange,
    title = 'RESEARCHERS'
}: ResearchTeamListFeatureProps) => {
    const modalService = useModalApiContext();
    const { userCanEdit } = useResearchTeamPermissions(dataRequest);
    const createResearcher = useResearchTeamCreate();
    const getTeamMemberId = useResearchTeamMemberId();
    const useFilteredMembers = false;

    const handleResearcher = (teamMember: IResearchTeamMemberDetail) => {
        const newMember = createResearcher(ResearchTeamMemberRoleEnum.AdditionalResearcher);

        const modalId = modalService.custom(
            <TeamMemberModalComponent
                onSave={(teamMember) => {
                    modalService.dismiss(modalId);
                }}
                onCancel={() => modalService.dismiss(modalId)}
                teamMember={teamMember}
                dataRequest={dataRequest}
            />,
            {
                style: {
                    width: '80%',
                    height: '80%',
                    overflowY: 'auto'
                }
            }
        );
    };

    if (!researchTeamMembers || !dataRequest) {
        return (
            <LoadIndicatorView
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            />
        );
    }

    return (
        <div style={containerStyle}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <FieldHeaderComponent title={title} />
                    {userCanEdit && (
                        <ButtonView style={btnStyle} onClick={handleResearcher} dataId={DTICommonConst.AddButton}>
                            Add +
                        </ButtonView>
                    )}
                </div>
            </div>

            <ResearchTeamGridComponent members={researchTeamMembers} draftMode={false} onRemove={onRemove} onChange={onChange} />
        </div>
    );
};
